import React, { useEffect } from 'react';

import { Box } from 'components';
import { useIsMobile } from 'hooks';

import { Navigation } from '../Navigation/Navigation';

import { RouterOutlet, useSelector, useTheme } from 'third-party';

import { useBilling } from 'modules/billing';

import { appSelectors } from 'selectors';

import { navGradient } from 'styles/theme';

export const MainView = () => {
  const isNavigationCollapsed = useSelector(appSelectors.isNavigationCollapsed);
  const theme = useTheme();
  const isMobile = useIsMobile();
  const organizationId = useSelector(appSelectors.organizationId);
  const { clearEntitlement, loadEntitlement } = useBilling();

  useEffect(() => {
    if (organizationId) {
      loadEntitlement();
    }

    return () => {
      clearEntitlement();
    };
  }, [organizationId, loadEntitlement, clearEntitlement]);

  return (
    <Box sx={{ display: 'flex', height: '100%', width: '100%' }}>
      <Box
        sx={{
          display: isMobile ? 'none' : 'flex',
          flexDirection: 'column',
          borderRight: `1px solid ${theme.custom.palette.borderColor}`,
          background: navGradient,
          width: isNavigationCollapsed ? '5.5rem' : '14rem',
          transition: 'width 0.3s ease-in-out',
          flexShrink: 0,
        }}
      >
        <Navigation />
      </Box>
      {isMobile && <Navigation />}
      <Box
        sx={{
          display: 'flex',
          overflow: 'auto',
          flexDirection: 'column',
          flexGrow: 1,
          margin: isMobile ? '4rem 0.5rem 0.5rem 0' : '1rem',
          width: isMobile ? '100%' : 'auto',
          padding: isMobile ? '0 1rem' : '0',
          transition: 'margin-left 0.3s ease-in-out',
        }}
      >
        <RouterOutlet />
      </Box>
    </Box>
  );
};
